export default __webpack_public_path__ + "static/media/assista_horizontal.374f2a09.svg";